import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { FormLabel, Tooltip,TextArea} from 'carbon-components-react';

const FormTextArea = ({name, label, tooltipContent, helperText, disabled, rows, props}) => {
    const {register, formState, watch, setValue, trigger} = useFormContext(); 
    let obj = formState.errors[name];
    const [dateValue, setDateValue] = useState(null);
    const date = watch(name);

    if(!rows)
        rows = 4;

    const array = name.substr(0, name.indexOf("["));
    if(array.length > 0){
        const optionalName = name.replace('.', '?.');
        obj = formState.errors[array] ? eval(`formState.errors.${optionalName}`) : null;
    }
    useEffect(() => {
        setDateValue(date);
    }, [date]);

    const change = (e) => {
        setValue(name, e.target.value);
        trigger(name);
    }

    return ( 
        <>
        <FormLabel>
            {
            tooltipContent ?
            <Tooltip triggerText={label}>
                {tooltipContent}
            </Tooltip> 
            : <>{label}</>
            }
        </FormLabel>
        <TextArea
                    id={`txt-${name}`} {...register(name)} 
                    invalidText={obj?.message} 
                    invalid={!!obj} 
                    helperText={helperText} 
                    disabled={disabled} 
                    labelText="" 
                    hideLabel={true} 
                    onChange={change} 
                    {...props} 
                />
        </>
     );
}
 
export default FormTextArea;